import { render, staticRenderFns } from "./SearchByTagsAndBrand.vue?vue&type=template&id=3a52bdfc&scoped=true"
import script from "./SearchByTagsAndBrand.vue?vue&type=script&lang=js"
export * from "./SearchByTagsAndBrand.vue?vue&type=script&lang=js"
import style0 from "./SearchByTagsAndBrand.vue?vue&type=style&index=0&id=3a52bdfc&prod&scoped=true&lang=css"
import style1 from "./SearchByTagsAndBrand.vue?vue&type=style&index=1&id=3a52bdfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a52bdfc",
  null
  
)

export default component.exports